module.exports = __webpack_public_path__ + "assets/user_tab.ba884996.svg";